import { render, staticRenderFns } from "./StatusSubject.vue?vue&type=template&id=b4cc37d0&"
import script from "./StatusSubject.vue?vue&type=script&lang=js&"
export * from "./StatusSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports